const GpsIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="20" height="20" rx="10" transform="matrix(-1 0 0 1 20 0)" fill="white" />
      <path d="M16 10.5996L5.97149 5.02822L8.20005 10.5996L5.97149 16.171L16 10.5996Z" stroke="#4F6FAE" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default GpsIcon;
